module.exports = IcbuIM['Next1'].Icon;